export const getTokenExID = () => {
  return process.env.REACT_APP_TOKEN_EX_ID;
};
export const getTokenExSecretKey = () => {
  return process.env.REACT_APP_TOKEN_EX_SECRET_KEY;
};
export const getTokenExScheme = () => {
  return process.env.REACT_APP_TOKEN_EX_SCHEME;
};

export const getPaypalHostUrl = () => {
  return process.env.REACT_APP_PAYPAL_HOST_URL;
};
export const getPaypalClientId = () => {
  return process.env.REACT_APP_PAYPAL_CLIENT_ID;
};
export const getPaypalClientSecret = () => {
  return process.env.REACT_APP_PAYPAL_CLIENT_SECRET;
};

export const getChargBeeSiteName = () => {
  return process.env.REACT_APP_CHARGEBEE_SITE_NAME;
};
export const getChargBeeUserName = () => {
  return process.env.REACT_APP_CHARGEBEE_USER_NAME;
};

export const paymentMode = {
  NONE: 0,
  CHARGEBEE: 1,
  PAYPAL: 2,
  APPLEPAY: 3,
  GOOGLEPAY: 4,
};
